import React from 'react';
import style from './style.scss';
import StatisticalItem from './StatisticalItem.jsx';

class Statistical extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [
        {percent: 60, value: '11'},
        {percent: 80, value: '12'},
        {percent: 65, value: '13'},
        {percent: 40, value: '14'},
        {percent: 65, value: '15'},
        {percent: 70, value: '16'},
        {percent: 78, value: '17'},
        {percent: 30, value: '18'},
        {percent: 35, value: '19'},
        {percent: 48, value: '20'},
        {percent: 32, value: '21'},
        {percent: 59, value: '22'},
        {percent: 60, value: '23'},
      ],
      dataColor: [
        {fillColor: '#9ED1F0'},
        {fillColor: '#97CDF0'},
        {fillColor: '#8EC9F0'},
        {fillColor: '#84C4F0'},
        {fillColor: '#79BFF0'},
        {fillColor: '#6EBAF0'},
        {fillColor: '#60B4F0'},
        {fillColor: '#54AEF0'},
        {fillColor: '#54AEF0'},
        {fillColor: '#47A9F0'},
        {fillColor: '#319FF0'},
        {fillColor: '#2A9BF0'},
        {fillColor: '#2297F0'}
      ]
    }
  }

  render() {
    return (
      <div className='the-news-wrap-item'>
        <section className="statistical">
          <h2 className='statistical-title'>{this.props.title}</h2>
          <div className='statistical-left'>
            {
              this.state.data.map((item, i) => {
                return <StatisticalItem key={i} fillColor={this.state.dataColor[i].fillColor} {...item}/>
              })
            }
          </div>
          <div className='statistical-right'>
            <div className='statistical-sum-item'>
              <p className='statistical-sum-percent'>75%</p>
              <p className='statistical-sum-text'>giá trị</p>
            </div>

            <div className='statistical-sum-item'>
              <p className='statistical-sum-percent'>92%</p>
              <p className='statistical-sum-text'>giá trị</p>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Statistical;



// WEBPACK FOOTER //
// ./components/my-business/sub-view/the-news/statistical/Statistical.jsx